const scope = typeof global === 'undefined' ? window : global;

scope.__DEV__ = process.env.NODE_ENV === 'development';
scope.__TEST__ = process.env.NODE_ENV === 'test';
scope.__PROD__ = process.env.NODE_ENV === 'production';
